module.exports = __webpack_public_path__ + "img/more.96125e7a.png";